import request from '@/utils/request'

export function getCsSession() {
  return request({
    url: '/swx/customer/cs/session',
    method: 'get'
  })
}

export function getCsMessages(params) {
  return request({
    url: '/swx/customer/cs/messages',
    method: 'get',
    params
  })
}

export function sendCsMessage(data) {
  return request({
    url: '/swx/customer/cs/send',
    method: 'post',
    data
  })
}

export function markCsRead(data) {
  return request({
    url: '/swx/customer/cs/read',
    method: 'post',
    data
  })
}
